import React, { FC, ReactElement } from 'react'

export const PreviewIcon: FC = (): ReactElement => (
    <svg width='18px' height='18px' viewBox='0 0 100 100'>
        <path
            fill='currentColor'
            d='m83 95h-66c-6.6016 0-12-5.3984-12-12v-66c0-6.6016 5.3984-12 12-12h66c6.6016 0 12 5.3984 12 12v66c0 6.6016-5.3984 12-12 12zm-70-66v54c0 2.1992 1.8008 4 4 4h66c2.1992 0 4-1.8008 4-4v-54zm0-8h74v-4c0-2.1992-1.8008-4-4-4h-66c-2.1992 0-4 1.8008-4 4zm37 57c-18.898 0-28.199-17.398-28.5-18.199-0.60156-1.1992-0.60156-2.5 0-3.6992 0.30078-0.70312 9.6016-18.102 28.5-18.102s28.199 17.398 28.5 18.199c0.60156 1.1992 0.60156 2.5 0 3.6992-0.30078 0.70312-9.6016 18.102-28.5 18.102zm-20.301-20c2.5 3.8008 9.3008 12 20.301 12s17.801-8.1992 20.301-12c-2.5-3.8008-9.3008-12-20.301-12s-17.801 8.1992-20.301 12zm20.301 4c-2.1992 0-4-1.8008-4-4s1.8008-4 4-4 4 1.8008 4 4-1.8008 4-4 4z'
        />
    </svg>
)
